import React from 'react';
import ProceedingList from '../components/ProceedingList';

export default function ProceedingListPage() {
  return (
      <ProceedingList />
  );
}
